module.exports = __webpack_public_path__ + "static/TT-Testfit_Floor07-2eac1fe1b7da1e0cbccc2881f61d028c.jpg";